import React, { useEffect } from 'react'
import SearchField from '@molecules/SearchField'
import { scopedTranslation } from '@utils/I18n'
import { useForm } from 'react-hook-form'
import useEventsFilteringStore from './stores/useEventsFilteringStore'

const t = scopedTranslation('shifts_overview.search_field')

function eventSearchField() {
  const searchTerm = useEventsFilteringStore((state) => state.searchTerm)
  const setSearchTerm = useEventsFilteringStore((state) => state.setSearchTerm)

  const { register, handleSubmit, setValue } = useForm({
    defaultValues: { event_name: searchTerm },
  })

  useEffect(() => {
    setValue('event_name', searchTerm)
  }, [searchTerm])

  const onSubmit = (data: { event_name: string }) => {
    setSearchTerm(data.event_name)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="tw-w-full">
      <SearchField
        {...register('event_name', {
          onChange: (e: React.ChangeEvent<HTMLInputElement>) => {setSearchTerm(e.target.value)},
        })}
        fieldName="event_name"
        placeholder={t('label')}
        displayName={t('label')}
        dataCompId="shifts-overview_search-field"
      />
    </form>
  )
}

export default eventSearchField